import { Component, forwardRef, OnDestroy, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  NG_VALIDATORS
} from '@angular/forms';
import { Subscription } from 'rxjs';

export interface ItemFormValues {
  name: string;
  details: string;
  price: number;
  quantity: number;
  tax:any;
  taxable: boolean;
};
const FIELD_NAMES =  ['name','details','price','quantity','taxable','tax'];

@Component({
  selector: 'app-item-form',
  templateUrl: './item-form.component.html',
  styleUrls: ['./item-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ItemFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ItemFormComponent),
      multi: true
    }
  ]
})
export class ItemFormComponent implements ControlValueAccessor, OnInit,OnDestroy  {
  form: FormGroup;
  subscriptions: Subscription[] = [];

  @Input()
  requiredFields: string[] = [];
  @Input()
  labelPosition: string = 'floating';
  @Input()
  listLines: string = 'full';

  get value(): ItemFormValues {
    return this.form.value;
  }

  set value(value: ItemFormValues) {
    if(value && typeof value.tax == 'undefined'){
      value.tax = null;
    }
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(private formBuilder: FormBuilder) {

  }



  ngOnInit(){
    const group = FIELD_NAMES.reduce( (g:any,name:string)=>{
      if(this.requiredFields.includes(name)){
        g[name]= ['', Validators.required ];
      }else{
        g[name] = [ ];
      }
      return g;
    }, {})
    this.form = this.formBuilder.group(group);
    window.requestAnimationFrame( ()=>{
      this.form.get('taxable').setValue(true);
    });

    this.subscriptions.push(
      this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onChange: any = () => { };
  onTouched: any = () => { };
  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value ?? null;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null :  Object.keys(this.form.controls).reduce( (errs:any,key:string)=>{
        if(!this.form.controls[key].valid){
          errs[key]=this.form.controls[key].errors
        }
        return errs;
      },{})
  }

}
